/**
 * Admin V3 — Operations / Live — Search bar
 *
 * Layout (left → right):
 *   [Search input] [Result counter]
 *
 * NO CSV export (owner ruling #11 — no backend export endpoint exists).
 * NO status filter (the /admin/control-tower/live endpoint is fixed-filter
 * to active statuses server-side).
 *
 * Search is SERVER-SIDE via the endpoint's `search` query param
 * (admin_control_tower_v2.py:292-427 supports id/reference/phone/email).
 *
 * Class strings mirror OnboardingListSearchBar / DriversListSearchBar
 * (Phase 2.3-2.4) for operator UX consistency across V3 modules.
 */

import React from 'react';
import { Search, X } from 'lucide-react';
import { t } from '../../i18n';

const OperationsLiveSearchBar = ({
  search,
  onSearchChange,
  resultsCount,
  isFilterActive,
  loading,
  locale = 'fr',
}) => {
  const resultsCountText = t('operations.live.results.count', locale).replace('{n}', String(resultsCount));

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search (server-side) */}
      <div className="relative flex-1 max-w-md min-w-[240px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('operations.live.search.placeholder', locale)}
          data-testid="adminv3-operations-live-search"
          className="w-full rounded-xl border border-slate-200 bg-slate-50 py-2.5 pl-10 pr-9 text-sm text-slate-900 outline-none focus:border-rose-400 focus:ring-2 focus:ring-rose-100"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
            data-testid="adminv3-operations-live-search-clear"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Result counter (only when search is active and not loading) */}
      {isFilterActive && !loading && (
        <span className="text-sm text-slate-400" data-testid="adminv3-operations-live-results-count">
          {resultsCountText}
        </span>
      )}
    </div>
  );
};

export default OperationsLiveSearchBar;
